"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (_element, _context) => {
    return '---\n\n';
};
exports.toMarkdown = toMarkdown;
